/**
 * 3.0 콜랩을 앱에서 여는 경로 — 앱 `app/(wo-tabs)/collabs/[id]/*` 와 같은 주소.
 * @description 웹은 같은 경로를 딥링크로 넘긴다(`openInApp`). 스레드 글은 `thread/{postId}`, 작품은
 *   `thread/{workId}?type=work` — 계약 `CollabV3LinkAttachmentSchema` 의 이동 규칙이자 앱 링크 해석과
 *   같다. 앱 라우트가 바뀌면 여기를 맞춘다.
 * @example collabV3AppPaths(404).threadItem(971) // "/collabs/404/thread/971"
 */
import { routes } from "@/shared/config/routes";

export const collabV3AppPaths = (collabId: number) => {
  const detail = routes.collabs.detail(collabId);
  const thread = `${detail}/thread`;
  return {
    detail,
    thread,
    works: `${thread}/works`,
    threadItem: (postId: number) => `${thread}/${postId}`,
    work: (workId: number) => `${thread}/${workId}?type=work`,
  };
};
